module.exports = __webpack_public_path__ + "ba6962bf6568e3b8a6fa13be34695317.svg";